import { CERTIFICATE_AUTHORITY_ROLE } from './role-acl'

import type { TLMSAdminEditableField, TLMSAdminFormValues } from './types'

export const buildAdminFormPayload = ({
  mode,
  values,
  editableFields = [],
}: {
  mode: 'create' | 'update'
  values: TLMSAdminFormValues
  editableFields?: TLMSAdminEditableField[]
}): TLMSAdminFormValues => {
  const { name, ...valuesWithoutName } = values
  const normalizedName = name?.trim()
  const shouldIncludeName =
    values.role === CERTIFICATE_AUTHORITY_ROLE && normalizedName

  if (mode === 'create') {
    return {
      ...valuesWithoutName,
      ...(shouldIncludeName ? { name: normalizedName } : {}),
    }
  }

  const updateValues: TLMSAdminFormValues = {
    email: values.email,
  }

  if (editableFields.includes('name') && shouldIncludeName) {
    updateValues.name = normalizedName
  }

  if (editableFields.includes('role')) {
    updateValues.role = values.role
  }

  return updateValues
}
